import $ from 'jquery'

import { useState } from 'hooks'
import { getExportDefinitionSelectors } from 'selectors'

type State = {
	container?: HTMLElement
	checkAllDisplay?: HTMLElement
	checkAllTranslation?: HTMLElement
	checkAllTranslationHeader?: HTMLElement
	displayCheckboxes?: HTMLElement
	translateCheckboxes?: HTMLElement
	translateHeaderCheckboxes?: HTMLElement
	questionnairesSelect?: HTMLSelectElement
	feedbackTableIncludedSelect?: HTMLSelectElement
}

export const ExportDefinition = () => {
	const { state, setState } = useState<State>()

	const initExportDefinition = () => {
		const {
			checkAllDisplay,
			checkAllTranslation,
			checkAllTranslationHeader,
			displayCheckboxes,
			translateCheckboxes,
			translateHeaderCheckboxes,
		} = state

		if (
			!checkAllDisplay ||
			!checkAllTranslation ||
			!checkAllTranslationHeader ||
			!displayCheckboxes ||
			!translateCheckboxes ||
			!translateHeaderCheckboxes
		) {
			return
		}

		const allButtons = [
			{
				selectAllButton: checkAllDisplay,
				eachButtonSelector: displayCheckboxes,
			},
			{
				selectAllButton: checkAllTranslation,
				eachButtonSelector: translateCheckboxes,
			},
			{
				selectAllButton: checkAllTranslationHeader,
				eachButtonSelector: translateHeaderCheckboxes,
			},
		]

		allButtons.forEach((button) => {
			button.selectAllButton.addEventListener('click', () => {
				checkUncheckAll(button.eachButtonSelector, button.selectAllButton.checked)
			})
			watchCheckedAll(button.eachButtonSelector, button.selectAllButton)
		})

		const { questionnairesSelect, feedbackTableIncludedSelect } = state
		if (!questionnairesSelect || !feedbackTableIncludedSelect) return

		const selects = [questionnairesSelect, feedbackTableIncludedSelect]
		selects.forEach((select) => {
			select.addEventListener('change', () => {
				// @ts-ignore
				$.nette.ajax({
					type: 'POST',
					url: questionnairesSelect.getAttribute('data-getcolumnslink'),
					data: {
						questionnaireId: questionnairesSelect.value,
						feedbackTableIncluded: feedbackTableIncludedSelect.value,
					},
				})
			})
		})
	}

	const checkUncheckAll = (checkboxTypes, checked) => {
		if (!checkboxTypes) return
		checkboxTypes.forEach((checkbox) => {
			if (checkbox.disabled === true) {
				return
			}
			checkbox.checked = checked
		})
	}

	const watchCheckedAll = (checkboxes, checkAllCheckbox) => {
		checkboxes.forEach((checkbox) => {
			checkbox.addEventListener('click', () => {
				if (!isAllCheckboxesChecked(checkboxes)) {
					checkAllCheckbox.checked = false
				}
			})
		})
	}

	const isAllCheckboxesChecked = (checkboxes) => {
		// eslint-disable-next-line no-restricted-syntax
		for (const checkbox of checkboxes) {
			if (checkbox.checked === false) {
				return false
			}
		}
		return true
	}

	const init = () => {
		setState({ ...getExportDefinitionSelectors() })

		initExportDefinition()
	}

	return {
		init,
	}
}
